module.exports = __webpack_public_path__ + "static/hero-hcp-home-large-7ea4cca0b4c9536ca5b3a45fd023d6e1.png";